import * as React from 'react';
import styles from './index.less';
import { AddAPolicyAction, UpdateAPolicyAction } from '@/models/exhibitInfoPage';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, ExhibitInfoPageModelState } from '@/models/connect';
import FPolicyList from '@/components/FPolicyList';
import { FI18n } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import fPolicyBuilder3 from '@/components/fPolicyBuilder3';

interface PoliciesProps {
  dispatch: Dispatch;
  exhibitInfoPage: ExhibitInfoPageModelState;
}

function Policies({ dispatch, exhibitInfoPage }: PoliciesProps) {
  async function addPolicy() {
    // console.log(
    //   exhibitInfoPage.exhibit_BelongNode_ID,
    //   'Number(exhibitInfoPage.exhibit_ID) wioejfsd;jkfjk;jlk',
    // );
    const policy = await fPolicyBuilder3({
      alreadyUsedTexts: exhibitInfoPage.policy_List.map((p) => {
        return p.policyText;
      }),
      alreadyUsedTitles: exhibitInfoPage.policy_List.map((p) => {
        return p.policyName;
      }),
      resourceTypeCode: [exhibitInfoPage.exhibit_ResourceTypeCode],
      nodeID: exhibitInfoPage.exhibit_BelongNode_ID,
    });

    if (!policy) {
      return false;
    }

    await dispatch<AddAPolicyAction>({
      type: 'exhibitInfoPage/addAPolicy',
      payload: {
        text: policy.text,
        title: policy.title,
      },
    });
  }

  return (
    <div className={styles.block}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.tAuto('edit_exhibit_authplan')}
          type={'highlight'}
        />

        {exhibitInfoPage.policy_List.length !== 0 && (
          <FComponentsLib.FTextBtn
            style={{ fontSize: 12 }}
            type='primary'
            onClick={async () => {
              // onChangeIsEditing(false);
              // dispatch<OnClick_CancelEditIntroductionBtn_Action>({
              //   type: 'resourceInfoPage/onClick_CancelEditIntroductionBtn',
              // });
              // set$isEdit(false);
              self._czc?.push(['_trackEvent', '授权策略页', '创建授权策略', '', 1]);
              await addPolicy();
            }}
          >
            {/*添加授权策略*/}
            {FI18n.i18nNext.tAuto('edit_exhibit_authplan_btn_add')}
          </FComponentsLib.FTextBtn>
        )}
      </div>
      <div style={{ height: 20 }} />
      {exhibitInfoPage.policy_List.length === 0 && (
        <div className={styles.empty}>
          <div style={{ height: 10 }} />
          {FI18n.i18nNext
            .t('edit_exhibit_authplan_info')
            .split('<br />')
            .map((text, textIndex) => {
              return (
                <FComponentsLib.FContentText
                  // text={'资源需添加授权策略才能上架到资源市场，开放签约。'}
                  text={text}
                  type={'additional2'}
                  key={textIndex}
                />
              );
            })}
          {/* <FComponentsLib.FContentText
          text={'资源需添加授权策略才能上架到资源市场，开放签约。'}
          type={'additional2'}
        /> */}
          {/*<FComponentsLib.FContentText*/}
          {/*  text={'授权策略，即资源对外授权范围和条件的申明，如支付10元获得一个月使用授权。'}*/}
          {/*  type={'additional2'}*/}
          {/*/>*/}
          <div style={{ height: 20 }} />
          <FHotspotTooltip
            id={'exhibitDetailPage.createFirstPolicy'}
            style={{ left: -40, top: 4 }}
            text={FI18n.i18nNext.tAuto('hotpots_createauthplan_exhibit_btn_createauthplan')}
            onMount={() => {
              fSetHotspotTooltipVisible('exhibitDetailPage.createFirstPolicy', {
                value: false,
                effectiveImmediately: false,
                onlyNullish: true,
              });
            }}
          >
            <FComponentsLib.FRectBtn
              onClick={async () => {
                fSetHotspotTooltipVisible('exhibitDetailPage.createFirstPolicy', {
                  value: false,
                  effectiveImmediately: true,
                  onlyNullish: false,
                });
                self._czc?.push(['_trackEvent', '授权策略页', '创建授权策略', '', 1]);
                await addPolicy();
              }}
              type='primary'
            >
              {FI18n.i18nNext.tAuto('edit_exhibit_authplan_btn_add')}
            </FComponentsLib.FRectBtn>
          </FHotspotTooltip>
          <div style={{ height: 20 }} />
        </div>
      )}

      {exhibitInfoPage.policy_List.length > 0 && (
        <FPolicyList
          atLeastOneUsing={exhibitInfoPage.exhibit_Online}
          dataSource={exhibitInfoPage.policy_List}
          onCheckChange={(data) => {
            if (data.using) {
              self._czc?.push(['_trackEvent', '授权策略页', '上线', '', 1]);
            }
            dispatch<UpdateAPolicyAction>({
              type: 'exhibitInfoPage/updateAPolicy',
              payload: { id: data.id, status: data.using ? 1 : 0 },
            });
          }}
        />
      )}
    </div>
  );
}

export default connect(({ exhibitInfoPage }: ConnectState) => ({
  exhibitInfoPage,
}))(Policies);
